import * as React from "react"
import { cn } from "@/lib/utils"
import { Button } from "@/components/ui/button"

function EmptyState({
  title,
  description,
  action,
  className,
  ...props
}: React.ComponentProps<"div"> & {
  title: string
  description?: string
  action?: React.ReactNode
}) {
  return (
    <div
      data-slot="empty-state"
      className={cn(
        "flex flex-col items-center justify-center gap-3 p-8 text-center",
        className,
      )}
      {...props}
    >
      <h2 className="text-h2 font-medium text-neutral-text-900">{title}</h2>
      {description ? (
        <p className="max-w-md text-body2 text-neutral-text-500">{description}</p>
      ) : null}
      {action}
    </div>
  )
}

function ErrorState({
  title = "Что-то пошло не так",
  description = "Произошла ошибка. Попробуйте обновить страницу.",
  detail,
  onRetry,
  children,
  className,
  ...props
}: React.ComponentProps<"div"> & {
  title?: string
  description?: string
  detail?: string
  onRetry?: () => void
}) {
  return (
    <div
      data-slot="error-state"
      role="alert"
      className={cn(
        "flex flex-col items-center justify-center gap-3 p-8 text-center",
        className,
      )}
      {...props}
    >
      <h2 className="text-h3 font-medium text-neutral-text-900">{title}</h2>
      <p className="max-w-md text-body2 text-neutral-text-500">{description}</p>
      {detail ? (
        <pre className="max-w-md overflow-x-auto rounded-s bg-neutral-background-100 p-2 text-left text-caption text-neutral-text-500">
          {detail}
        </pre>
      ) : null}
      {children}
      {onRetry ? (
        <Button type="button" variant="secondary" onClick={onRetry}>
          Обновить
        </Button>
      ) : null}
    </div>
  )
}

export { EmptyState, ErrorState }
